module.exports = __webpack_public_path__ + "img/LUB00390.f8a4b52f.png";